<div class="seller-invoices-list">
    <page-header i18n-title titleText="Invoices"> </page-header>
    <div class="page-container container-fluid">
        <tabs *featureFlag="featureFlags.PendingCreditMemos" [tabsConfig]="tabsConfig"></tabs>
        <ng-container
            *ngIf="
                (activeTabLabel$ | async) === routeQueryParams.InvoicesTab ||
                (activeTabLabel$ | async) === undefined
            "
        >
            <card *ngIf="!(responsiveService.mdBelow | async)" id="invoices-table-card">
                <div right-header-content>
                    <ng-container *ngTemplateOutlet="filtersForm"></ng-container>
                </div>
                <div card-body class="invoice-table">
                    <lsq-data-table
                        [hasHeader]="true"
                        [isPaginated]="true"
                        [layoutFixed]="true"
                        [dataSource]="tableDataSource"
                        [trackBy]="trackByInvoiceKey"
                        [getRowClassName]="getRowClassNameBound"
                        (skipChanged)="expandedGroupInvoiceKeys.clear()"
                        (takeChanged)="expandedGroupInvoiceKeys.clear()"
                    >
                        <lsq-column
                            [column]="{
                                key: 'isGroup',
                                width: '4.5rem',
                                sortable: false
                            }"
                        >
                            <ng-template [custom-cell] let-row="row" let-index="index">
                                <div
                                    [class.counter]="row.refGroupedInvoiceKey"
                                    [style.padding-top]="row.isGroup ? 0 : undefined"
                                    [style.padding-bottom]="row.isGroup ? 0 : undefined"
                                >
                                    <ng-container *ngIf="row.isGroup">
                                        <div
                                            class="invoice-group-expand-button"
                                            [attr.tabindex]="0"
                                            (click)="handleInvoiceGroupToggleClick(row)"
                                        >
                                            <lsq-icon
                                                [type]="
                                                    expandedGroupInvoiceKeys.has(row.refInvoiceKey)
                                                        ? icons.ChevronDown
                                                        : icons.ChevronRight
                                                "
                                                [color]="color.Black"
                                            >
                                            </lsq-icon>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="row.refGroupedInvoiceKey">
                                        {{
                                            row
                                                | getOffsetIndexOfSiblingRow
                                                    : index
                                                    : 'refInvoiceKey'
                                                    : 'isGroup'
                                                | async
                                        }}
                                    </ng-container>
                                </div>
                            </ng-template>
                        </lsq-column>
                        <lsq-column
                            [column]="{
                                key: 'invoiceNumber',
                                header: invoiceNumberHeader,
                                truncateAfter: invoiceNumberTruncateAfter$ | async,
                                reverseTruncate: true,
                                onCellClick: openInvoiceDetailsBound,
                                isClickableFunction: isInvoiceClickableBound,
                                sortable: true
                            }"
                        >
                        </lsq-column>

                        <lsq-column
                            [column]="{
                                header: statusHeader,
                                key: 'fundingStatus',
                                sortable: true
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <status-pill
                                    [status]="getInvoiceStatus(row)"
                                    [color]="
                                        statusColor[
                                            invoiceFundingStatusDotEnum[getInvoiceStatus(row)]
                                        ]
                                    "
                                    [displayValueMap]="invoiceFundingStatusDisplay"
                                >
                                </status-pill>
                            </ng-template>
                        </lsq-column>
                        <lsq-date-column
                            [displayNullIfFieldIsTrue]="'isGroup'"
                            [column]="{
                                header: invoiceDateHeader,
                                key: 'invoiceDate',
                                sortable: true
                            }"
                        ></lsq-date-column>

                        <lsq-date-column
                            [column]="{
                                header: invoiceDueDateHeader,
                                key: 'invoiceDueDate',
                                sortable: true
                            }"
                        ></lsq-date-column>

                        <lsq-column
                            [alignRight]="true"
                            [column]="{
                                key: 'dueIn',
                                header: dueHeader,
                                sortable: true,
                                className: 'column-dueIn'
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <ng-container
                                    *ngIf="
                                        row.fundingStatus === invoiceFundingStatus.FUNDED;
                                        else dueInDays
                                    "
                                >
                                    {{ nullValue }}
                                </ng-container>
                                <ng-template #dueInDays>
                                    {{ row.dueIn | days }}
                                </ng-template>
                            </ng-template>
                        </lsq-column>
                        <lsq-currency-column
                            [column]="{
                                key: 'finalApprovedAmount',
                                header: amountHeader,
                                sortable: true
                            }"
                        ></lsq-currency-column>
                    </lsq-data-table>
                </div>
            </card>

            <div *ngIf="responsiveService.mdBelow | async">
                <ng-container *ngTemplateOutlet="filtersForm"></ng-container>
                <lsq-data-table-mobile [dataSource]="tableDataSource" [isPaginated]="true">
                    <ng-template #mobileCardHeader let-row="row">
                        <div class="mtc-header-content">
                            <div class="invoice-list-mobile-card-header">
                                <div class="mtc-header-content-left">
                                    <div class="mtc-header-title">
                                        {{ invoiceNumberLabel }}&nbsp;{{ row.invoiceNumber }}
                                    </div>
                                    <div class="mtc-header-sub-title">
                                        {{ amountHeader }}&nbsp;
                                        <span class="invoice-available-value">
                                            {{ row.finalApprovedAmount | lsqCurrency }}
                                        </span>
                                    </div>
                                </div>
                                <div class="mtc-header-content-right">
                                    <div class="invoice-status">
                                        <status-pill
                                            [status]="getInvoiceStatus(row)"
                                            [color]="
                                                statusColor[
                                                    invoiceFundingStatusDotEnum[
                                                        getInvoiceStatus(row)
                                                    ]
                                                ]
                                            "
                                            [displayValueMap]="invoiceFundingStatusDisplay"
                                        >
                                        </status-pill>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template #mobileCardColumns let-row="row">
                        <div class="card-item">
                            <div class="card-item-label">
                                Buyer
                            </div>
                            <div class="card-item-value">
                                {{ row.buyerName }}
                            </div>
                        </div>
                        <div class="card-item">
                            <div class="card-item-label">
                                {{ invoiceDateHeader }}
                            </div>
                            <div class="card-item-value">
                                {{
                                    row.invoiceDate && !row.isGroup
                                        ? (row.invoiceDate | lsqDate: 'shortDate')
                                        : nullValue
                                }}
                            </div>
                        </div>
                        <div class="card-item">
                            <div class="card-item-label">
                                {{ invoiceDueDateHeader }}
                            </div>
                            <div class="card-item-value">
                                {{
                                    row.invoiceDueDate
                                        ? (row.invoiceDueDate | lsqDate: 'shortDate')
                                        : nullValue
                                }}
                            </div>
                        </div>
                        <div class="card-item">
                            <div class="card-item-label">
                                {{ dueHeader }}
                            </div>
                            <div class="card-item-value">
                                <ng-container
                                    *ngIf="
                                        row.fundingStatus === invoiceFundingStatus.FUNDED;
                                        else dueInDays
                                    "
                                >
                                    {{ nullValue }}
                                </ng-container>
                                <ng-template #dueInDays>
                                    {{ row.dueIn | days }}
                                </ng-template>
                            </div>
                        </div>
                        <div
                            class="card-item"
                            *ngIf="isBuyerPaidEarlyFeePercentageVisible$ | async"
                        >
                            <div class="card-item-label">
                                {{ buyerDiscountHeader }}
                            </div>
                            <div class="card-item-value">
                                <span>
                                    {{ row.buyerDiscountAmount | currencyDash }}
                                </span>
                            </div>
                        </div>
                        <div
                            class="card-item"
                            *ngIf="isBuyerPaidEarlyFeePercentageVisible$ | async"
                        >
                            <div class="card-item-label">
                                {{ supplierDiscountHeader }}
                            </div>
                            <div class="card-item-value">
                                <span>
                                    {{ row.supplierDiscountAmount | currencyDash }}
                                </span>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #mobileCardFooter let-row="row">
                        <div class="mtc-footer-link">
                            <lsq-button
                                *ngIf="isInvoiceClickableBound(row)"
                                appearance="transparent"
                                (buttonClick)="openInvoiceDetailsBound(row)"
                                i18n
                            >
                                Invoice Details
                            </lsq-button>
                        </div>
                    </ng-template>
                </lsq-data-table-mobile>
            </div>
        </ng-container>
        <ng-container *ngIf="(activeTabLabel$ | async) === routeQueryParams.PendingCreditMemosTab">
            <supply-chain-direct-seller-pending-credit-memos></supply-chain-direct-seller-pending-credit-memos>
        </ng-container>
    </div>

    <ng-template #filtersForm>
        <div class="invoices-header-right">
            <form class="invoices-filter" [formGroup]="filtersFormGroup">
                <div class="invoices-filters-invoice-number">
                    <lsq-input
                        i18n-placeholder
                        placeholder="Search Invoice Number"
                        formControlName="invoiceNumber"
                        [name]="'invoiceNumber'"
                        [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                        [group]="filtersFormGroup"
                    >
                    </lsq-input>
                </div>
                <div class="invoices-filters-status-filter">
                    <lsq-select
                        *ngIf="filterOptions"
                        [name]="'invoice-filter-select'"
                        [options]="filterOptions"
                        [group]="filtersFormGroup"
                        formControlName="invoiceFilter"
                    >
                    </lsq-select>
                </div>
            </form>
            <span class="export-button" *ngIf="!(responsiveService.mdBelow | async)">
                <lsq-export-button
                    [request]="tableDataSource.request | cacheValue: convertExportRequestBound"
                    [service]="getSellerInvoiceExportService"
                    [reportName]="reportName"
                    [isIcon]="true"
                    [disabled]="(tableDataSource.rows$ | async)?.length == 0"
                >
                </lsq-export-button>
            </span>
        </div>
    </ng-template>
</div>
